<template>
  <div class="enterprise-distribution">
    <!-- 标题：横跨整个区域 -->
    <div class="section-title">企业类型及分布</div>

    <div class="content-wrapper">
      <!-- 左侧：饼图 -->
      <div class="chart-section">
        <div class="chart-container">
          <Echart
              :options="chartOptions"
              id="EnterpriseDistributionChart"
              height="100%"
              width="100%"
          ></Echart>
          <div class="chart-center-info">
            <div class="center-label">总计</div>
            <div class="center-value">{{ totalCount }} 家</div>
          </div>
        </div>
      </div>

      <!-- 中间：条形图 -->
      <div class="bar-chart-section">
        <Echart
            :options="barChartOptions"
            id="EnterpriseCategoryChart"
            height="100%"
            width="100%"
        ></Echart>
      </div>

      <!-- 右侧：滚动列表 -->
      <div class="list-section">
        <div class="scroll-list-container">
          <div
              v-for="(item, index) in companyList"
              :key="index"
              :class="['scroll-item', { active: activeIndex === index }]"
          >
            <div class="item-number">{{ index + 1 }}</div>
            <div class="item-content">
              <div class="item-name">{{ item.name }}</div>
              <div class="item-type">{{ item.type }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from "@/utils/request";

export default {
  name: 'EnterpriseDistribution',
  // props: {
  //   qycyList: {
  //     type: Array,
  //     default: () => []
  //   },
  //   qylxfbList: {
  //     type: Array,
  //     default: () => []
  //   },
  //   qychList: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  data() {
    return {
      VUE_APP_API_BASE_URL:"https://dp.houkongfan.cn/",
      totalCount: 0,
      chartData: [
        // {name: '高端装备产业', value: 914, color: '#37ceff'},
        // {name: '智能制造产业', value: 507, color: '#b696ff'},
        // {name: '大快消产业', value: 278, color: '#ffce20'},
        // {name: '高端纺织产业', value: 574, color: '#c697a3'},
      ],
      companyList: [
        // {name: '江阴市海江高分子材料有限公司', type: '国家级小巨人企业'},
        // {name: '江阴市天马电源制造有限公司', type: '国家级小巨人企业'},
        // {name: '江苏新达科技有限公司', type: '国家级小巨人企业'},
        // {name: '江苏国瓷泓源光电科技有限公司', type: '国家级小巨人企业'},
        // {name: '无锡市尚领石英科技有限公司', type: '国家级小巨人企业'},
        // {name: '阿法拉伐（江阴）设备制造有限公司', type: '江阴市百强企业'},
        // {name: '江阴久盛科技有限公司', type: '江阴市百强企业'},
        // {name: '江苏新达科技有限公司', type: '江阴市百强企业'},
        // {name: '江阴市天马电源制造有限公司', type: '江阴市百强企业'},
        // {name: '江阴市海江高分子材料有限公司', type: '江阴市百强企业'},
        // {name: '无锡圣马科技有限公司', type: '江阴市百强企业'},
        // {name: '无锡市尚领石英科技有限公司', type: '江阴市百强企业'},
        // {name: '江阴市威腾铝箔合成材料有限公司', type: '江阴市百强企业'},
        // {name: '江阴双马重工装备有限公司', type: '江阴市百强企业'},
        // {name: '江苏锋菱超硬工具有限公司', type: '江阴市百强企业'},
        // {name: '江阴市万里锻件有限公司', type: '江阴市百强企业'},
        // {name: '江阴市澳星电气有限公司', type: '江阴市百强企业'},
        // {name: '江苏雪豹日化有限公司', type: '江阴市百强企业'},
      ],
      // 条形图数据
      barChartData: [
        {color: '#33caff'},
        {color: '#62b3ff'},
        {color: '#47bcff'},
        {color: '#7f9bff'},
        {color: '#facb35'},
        {color: '#10c9c3'},
        {color: '#0bc8a8'},
        {color: '#3b8cff'},
        {color: '#1de4ff'},
      ],
      activeIndex: 0,
      scrollTimer: null,
    }
  },
  computed: {
    chartOptions() {
      return {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} 家 ({d}%)',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00d9ff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
          },
        },
        legend: {
          show: true,
          left: 'center', bottom: 0,
          orient: 'horizontal',
          itemGap: 20,
          itemWidth: 14,
          itemHeight: 14,
          icon: 'circle',
          textStyle: {
            color: '#b0b0b0',
            fontSize: 14,
            fontWeight: 'bold',
          },
          //   formatter: (name) => {
          //     const item = this.chartData.find(d => d.name === name)
          //     return `${name} ${item ? item.value : ''}`
          //   },
        },

        series: [
          {
            name: '企业类型分布',
            type: 'pie',
            radius: ['45%', '70%'],
            center: ['50%', '40%'],
            startAngle: 90,
            avoidLabelOverlap: true,
            // itemStyle: {
            //   borderRadius: 8,
            //   borderColor: 'transparent',
            //   borderWidth: 2,
            // },
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}\n{c} 家',
              fontSize: 16,
              fontWeight: 'bold',
              color: '#fff',
              lineHeight: 18,
              overflow: 'none',
              width: null,
            },
            labelLine: {
              show: true,
              length: 20,
              length2: 10,
              lineStyle: {
                color: '#00d9ff',
                width: 1,
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 18,
                fontWeight: 'bold',
                color: '#fff',
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 217, 255, 0.5)',
              },
            },
            data: this.chartData.map(item => ({
              value: item.value,
              name: item.name,
              itemStyle: {
                color: item.color,
              },
            })),
          },
        ],
      }
    },
    barChartOptions() {
      const maxValue = Math.max(...this.barChartData.map(item => item.value))
      // 计算合适的最大值（向上取整到最近的10的倍数）
      const adjustedMax = Math.ceil(maxValue / 50) * 50
      return {
        backgroundColor: 'transparent',
        grid: {
          left: '35%',
          right: '8%',
          top: '5%',
          bottom: '5%',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: (params) => {
            const param = params[0]
            return `${param.name}<br/>${param.value} 家`
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00d9ff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
          },
        },
        xAxis: {
          type: 'value',
          max: adjustedMax,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#6b7d8f',
            fontSize: 18,
            width: 280,
            overflow: 'truncate',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.1)',
              type: 'dashed',
            },
          },
        },
        yAxis: {
          type: 'category',
          data: this.barChartData.map(item => item.name),
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff',
            fontSize: 15,
            fontWeight: 'bold',
            interval: 0,
            width: 200,
            overflow: 'truncate',
          },
        },
        series: [
          {
            type: 'bar',
            data: this.barChartData.map(item => ({
              value: item.value,
              itemStyle: {
                color: item.color,
                borderRadius: [0, 4, 4, 0],
              },
            })),
            barWidth: '50%',
            barGap: '20%',
            label: {
              show: true,
              position: 'right',
              formatter: '{c} 家',
              color: '#fff',
              fontSize: 14,
              fontWeight: 'normal',
            },
          },
        ],
      }
    },
  },
  mounted() {
    this.onloadData()
    this.startAutoScroll()
  },
  beforeDestroy() {
    this.stopAutoScroll()
  },
  methods: {

    async onloadData() {
      const url =this.VUE_APP_API_BASE_URL + "/dev-api/system/page1/queryList/model2"
      const result = await get(url)
      // 查询产业类型列表
      this.qycyList = result.data.qycyList
      // 查询企业类型分布列表
      this.qylxfbList = result.data.qylxfbList
      // 查询企业称号分布列表
      this.qychList = result.data.qychList
      if (result.success) {
        //产业类型分布
        this.chartData = this.qycyList.map(item => ({
          name: item.cyType,
          value: item.cyNum,
        }))
        this.totalCount = this.qycyList.reduce((sum, item) => sum + (parseInt(item.cyNum) || 0), 0);
        // 企业类型分布
        this.barChartData = this.qylxfbList.map((item, index) => ({
          name: item.qyType,
          value: item.qyNum,
          color: this.generateColor(index, this.qylxfbList.length)
        }));
        // 企业称号
        this.companyList = this.qychList.map(item => ({
          name: item.qyname,
          type: item.qych,
        }))
      }
    },
    generateColor(index, total) {
      // 使用HSL创建更丰富的颜色变化
      const hue = Math.floor((index * 360) / total);
      const saturation = 70 + Math.sin(index) * 20; // 50-90%饱和度变化
      const lightness = 50 + Math.cos(index) * 10;  // 40-60%亮度变化
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    },
    startAutoScroll() {
      this.scrollTimer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.companyList.length
        this.scrollToActive()
      }, 2000) // 每2秒切换一次
    },
    stopAutoScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
    scrollToActive() {
      this.$nextTick(() => {
        const container = this.$el.querySelector('.scroll-list-container')
        const activeItem = this.$el.querySelector('.scroll-item.active')
        if (container && activeItem) {
          // 获取所有项目，计算当前激活项的累计高度
          const allItems = container.querySelectorAll('.scroll-item')
          let calculatedTop = 0
          for (let i = 0; i < allItems.length; i++) {
            if (allItems[i] === activeItem) {
              break
            }
            calculatedTop += allItems[i].offsetHeight + 8 // 8px 是 margin-bottom
          }

          const containerHeight = container.clientHeight
          const itemHeight = activeItem.offsetHeight

          // 计算目标滚动位置，让激活项居中显示
          let targetScrollTop = calculatedTop - containerHeight / 2 + itemHeight / 2

          // 确保不会滚动到顶部或底部之外
          const maxScrollTop = container.scrollHeight - containerHeight
          targetScrollTop = Math.max(0, Math.min(targetScrollTop, maxScrollTop))

          // 总是滚动到激活项，确保它在可视区域内
          container.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth',
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.enterprise-distribution {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  // 标题：横跨整个区域
  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid rgba(0, 217, 255, 0.3);
    width: 100%;
  }

  .content-wrapper {
    display: flex;
    gap: 20px;
    flex: 1;
    min-height: 0;
  }

  // 左侧：饼图
  .chart-section {
    width: 540px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;

    .chart-container {
      position: relative;
      height: 400px;
      width: 100%;
      flex-shrink: 0;

      .chart-center-info {
        position: absolute;
        top: calc(50% - 50px);
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        pointer-events: none;

        .center-label {
          font-size: 20px;
          color: #fff;
          margin-bottom: 28px;
          font-weight: 700;
        }

        .center-value {
          font-size: 20px;
          font-weight: 700;
          color: #fff;
        }
      }
    }

    .chart-legend {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 15px;
      flex: 1;

      .legend-item {
        display: flex;
        align-items: center;
        gap: 8px;

        .legend-color {
          width: 12px;
          height: 12px;
          border-radius: 2px;
          flex-shrink: 0;
        }

        .legend-name {
          font-size: 14px;
          color: #fff;
          flex: 1;
        }

        .legend-value {
          font-size: 14px;
          color: #00d9ff;
          font-weight: 600;
        }
      }
    }
  }

  // 中间：条形图
  .bar-chart-section {
    flex: 1;
    min-width: 0;
    height: 100%;
  }

  // 右侧：滚动列表
  .list-section {
    width: 650px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;

    .scroll-list-container {
      flex: 1;
      overflow-y: auto;
      padding-right: 10px;
      min-height: 0;

      // 隐藏滚动条
      &::-webkit-scrollbar {
        width: 0;
        display: none;
      }

      // 针对 Firefox
      scrollbar-width: none;

      // 针对 IE
      -ms-overflow-style: none;

      .scroll-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 14px;
        margin-bottom: 10px;
        background: transparent;
        border: none;
        border-radius: 0;
        cursor: pointer;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          background: transparent;
          transform: translateX(4px);
        }

        &.active {
          background: transparent;
          box-shadow: none;
          z-index: 10;

          .item-number {
            background: transparent !important;
            border-radius: 0 !important;
            color: #ffc000 !important;
            box-shadow: none !important;
          }

          .item-name {
            color: #ffc000 !important;
            font-weight: 700 !important;
            font-size: 20px !important;
          }

          .item-content {
            color: #ffc000 !important;
          }

          .item-type {
            color: #ffc000 !important;
            font-size: 20px !important;
          }
        }

        .item-number {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #2b74ff;
          border-radius: 50%;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          flex-shrink: 0;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 0 8px rgba(43, 116, 255, 0.4);
        }

        .item-content {
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: center;
          gap: 10px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

          .item-name {
            font-size: 18px;
            color: rgb(131, 154, 170);
            font-weight: 500;
            margin-bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            flex: 1;
            font-weight: normal;
          }

          .item-type {
            font-size: 16px;
            color: rgb(131, 154, 170);
            flex-shrink: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            font-weight: normal;
          }
        }
      }
    }
  }
}
</style>

